import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const AzureIcon = () => (
  <SvgIcon viewBox="0 0 36 36">
    <path
      fill="#DD5900"
      d="M29.5 13.7L16.3.5c-.7-.7-1.9-.7-2.6 0l-2.8 2.8 3.4 3.4c.3-.1.5-.2.8-.2 1.3 0 2.3 1 2.3 2.3 0 .3 0 .6-.1.8l3.3 3.3c.3-.1.5-.2.8-.2 1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3-1.3 0-2.3-1-2.3-2.3 0-.3.1-.6.2-.8l-3.1-3.1v8.2c.8.4 1.3 1.2 1.3 2 0 1.3-1 2.3-2.3 2.3-1.3 0-2.3-1-2.3-2.3 0-1 .6-1.8 1.5-2.1V11c-.9-.3-1.5-1.2-1.5-2.1 0-.3.1-.6.2-.8L9.6 4.7l-9 9c-.7.7-.7 1.9 0 2.6l13.1 13.1c.7.7 1.9.7 2.6 0l13.1-13.1c.8-.7.8-1.9.1-2.6z"
    />
  </SvgIcon>
);

export default AzureIcon;
